import VueWorker from 'vue-worker';
import Vuelidate from 'vuelidate';
import Vue from 'vue';

import parseQuery from "./plugins/parseQuery.plugin";
import TopMenu from "./components/TopMenu/TopMenu";

Vue.use(Vuelidate);
Vue.use(VueWorker);
Vue.use(VueWorker);

Vue.use(parseQuery);

export default {
    name: 'app',
    template: require('./App.html'),
    components: { TopMenu }
}
